<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 详细信息
      </h3>
      <div class="tu-class">
        <el-form :model="propsParams" ref="ruleForm" label-width="170px">
          <el-card shadow="never" style="width: 50%">
            <el-form-item label="客户名称：" prop="customerName">
              <span>{{propsParams.customerName}}</span>
            </el-form-item>
            <el-form-item label="业务员：" prop="salesman">
              <span>{{propsParams.salesman}}</span>
            </el-form-item>
            <el-form-item label="公司地址：" prop="companyAddress">
              <span>{{propsParams.companyAddress}}</span>
            </el-form-item>
            <!--<el-form-item label="分成模式：" prop="commissionModel">
              <template>
                <span v-if="propsParams.commissionModel==0">比例模式</span>
                <span v-if="propsParams.commissionModel==1">底价模式</span>
                <span v-if="propsParams.commissionModel==2">流量池模式</span>
              </template>
            </el-form-item>-->
            <el-form-item label="使用设备：" prop="useDevice">
              <span>{{propsParams.useDevice}}</span>
            </el-form-item>
            <el-form-item label="使用场景：" prop="useScreen">
              <span>{{propsParams.useScreen}}</span>
            </el-form-item>
            <el-form-item label="联系人：" prop="linkman">
              <span>{{propsParams.linkman}}</span>
            </el-form-item>
            <el-form-item label="联系人电话：" prop="linkmanPhone">
              <span>{{propsParams.linkmanPhone}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <span>{{propsParams.remark}}</span>
            </el-form-item>
          </el-card>
          <el-card shadow="never" style="width: 50%">
            <div slot="header" class="clearfix">
              <span style="font-size: 20px; color: #181818; font-weight: 600">图片资料</span>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="使用设备的图片：" prop="useDevicePicture">
                        <el-image v-if="propsParams.useDevicePicture" class="avatar" :src="propsParams.useDevicePicture" :preview-src-list="[propsParams.useDevicePicture]"></el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业执照：" prop="businessLicensePicture">
                        <el-image class="avatar" :src="propsParams.businessLicensePicture" :preview-src-list="[propsParams.businessLicensePicture]"></el-image>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>
      </div>
    </div>

    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程历史跟踪
      </h3>
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
        <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
        <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
        <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import { getCustomerInfo } from "@/api/api.js";//附加单据
  import { historicActivityInstance } from "@/api/api.js";//记录展示
  export default {
    data() {
      return{
        id: undefined,
        processId: undefined,
        formData: {},
        tableData:[],
        propsParams: {}
      }
    },
    methods: {
      // 获取数据
      initData(){
        if (this.processId) {
          historicActivityInstance({processInstanceId: this.processId}).then(res=>{
            if (res.data.code == 200) {
              this.tableData = res.data.data;
              this.tableData.map((item,index)=>{
                item.ids = index + 1;
              })
            }
          });
        }
        getCustomerInfo({id: this.id}).then(res=>{
          if (res.data.code == 200) {
            this.propsParams = res.data.data;
          }
        })
      },

    },
    created() {
      this.processId =  this.$route.query.processId;
      this.id =  this.$route.query.id;
    },
    mounted() {
      this.initData()
    },
  };
</script>
<style scoped lang="less">
  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
  }

  .p_class {
    font-size: 20px;
    color: red;
    margin-bottom: 50px;
  }

  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    line-height: 138px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }
</style>


